import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './merchant-inbound-item-reject-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.func
  })
}

const defaultProps = {
  hiddenColumns  : [],
  isLoading      : false,
  rowButtonProps : {
    buttonText       : 'Process',
    buttonColour     : 'default',
    onButtonClick    : () => {},
    isButtonDisabled : () => {}
  }
}

/**
 * Table to display specific Merchant Inbound Item columns for curation
 * @param {Array<Object>} data - array of merchant_inbound_item objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const MerchantInboundItemRejectTable = ({
  hiddenColumns,
  data,
  pagination,
  onFetchData,
  isLoading,
  rowButtonProps
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps

  const columns = useMemo(
    () => tableColumns({
      buttonText,
      buttonColour,
      onButtonClick,
      isButtonDisabled
    }),
    [
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled
    ]
  )

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

MerchantInboundItemRejectTable.propTypes    = propTypes
MerchantInboundItemRejectTable.defaultProps = defaultProps

export default MerchantInboundItemRejectTable
